<template>
  <b-container fluid>
    <!-- <CustomNav :items="itemTabs" primary @item-click="(val) => (tabSelected = val)"></CustomNav> -->
    <template v-if="tabSelected == 1">
      <SummaryFleetStatus />
      <b-row>
        <b-col md="12">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title text-primary"><strong>REPORT FLEET AVAILABILITY & BREAKDOWN</strong></h4>
            </template>
            <template v-slot:body>
              <b-row>
                <b-col md="4" class="mb-3">
                  <v-multiselect v-model="params.vehicle_type_ids" placeholder="Search Fleet Type" label="name"
                    :options="vehicleTypes" :multiple="true" track-by="id" class="mr-2">
                    <span slot="noResult">Fleet type not found.</span>
                  </v-multiselect>
                </b-col>
                <b-col md="4" class="mb-3">
                  <v-multiselect v-model="params.vehicle_ids" placeholder="Search Vehicle" label="name"
                    :options="vehicleComputed" :multiple="true" track-by="id" class="mr-2">
                    <span slot="noResult">Vehicle not found.</span>
                  </v-multiselect>
                </b-col>
                <b-col md="3" class="mb-3 d-flex align-items-center">
                  <date-picker class="mb-2 mr-2" style="width: 220px" v-model="params.year" type="year"></date-picker>
                  <b-button :disabled="loadingExport" variant="outline-primary" @click="handleExportTechnical">
                    <b-spinner small v-if="loadingExport" class="mr-1" />
                    {{ loadingExport ? 'Exporting...' : 'Export' }}
                  </b-button>
                </b-col>
                <b-col md="12" class="mt-3">
                  <PercentageAvailability :params="params" />
                  <!-- <div class="w-100 d-flex justify-content-end">
                    <b-button variant="primary" @click="showDetail = true">Detail <i
                        class="fa fa-chevron-right ml-2"></i> </b-button>
                  </div> -->
                  <b-sidebar v-model="showDetail" title="Breakdown Record" right width="100%"
                    bg-variant="white" shadow backdrop>
                    <div class="px-5" v-if="showDetail">
                      <PlanAndEmergencyDetail :params="params" />
                    </div>
                  </b-sidebar>
                </b-col>
                <!-- <b-col md="12">
                  <Breakdown :params="params" />
                </b-col> -->
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col md="8">
          <BreakdownPercentage />
        </b-col>
        <b-col md="4">
          <BreakdownVsAvailability />
        </b-col>
      </b-row> -->
    </template>
    <template v-else>
      <SummaryTotalBudget />
      <b-row>
        <b-col md="6">
          <BudgetExpanse />
        </b-col>
        <b-col md="6">
          <BudgetPlanVsExpanse />
        </b-col>
      </b-row>
      <SummaryDocking />
      <b-row>
        <b-col md="6">
          <BudgetDockingCategory />
        </b-col>
        <b-col md="6">
          <BudgetExpanseVsPlan />
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>
<script>
import CustomNav from '@/src/components/global/CustomNav.vue'
import Breakdown from './TechnicalDashboardComponents/Breakdown.vue'
import BreakdownPercentage from './TechnicalDashboardComponents/BreakdownPercentage.vue'
import BreakdownVsAvailability from './TechnicalDashboardComponents/BreakdownVsAvailability.vue'
import PercentageAvailability from './TechnicalDashboardComponents/PercentageAvailability.vue'
import SummaryFleetStatus from './TechnicalDashboardComponents/SummaryFleetStatus.vue'
import SummaryTotalBudget from './TechnicalDashboardComponents/SummaryTotalBudget.vue'
import BudgetExpanse from './TechnicalDashboardComponents/BudgetExpanse.vue'
import BudgetPlanVsExpanse from './TechnicalDashboardComponents/BudgetPlanVsExpanse.vue'
import SummaryDocking from './TechnicalDashboardComponents/SummaryDocking.vue'
import BudgetDockingCategory from './TechnicalDashboardComponents/BudgetDockingCategory.vue'
import BudgetExpanseVsPlan from './TechnicalDashboardComponents/BudgetExpanseVsPlan.vue'
import moment from '@/node_modules/moment/moment'
import { fleetsActions, srActions, vehiclesActions } from '@/src/Utils/helper'
import PlanAndEmergencyDetail from './TechnicalDashboardComponents/PlanAndEmergencyDetail.vue'

export default {
  components: {
    SummaryFleetStatus,
    BreakdownPercentage,
    PercentageAvailability,
    Breakdown,
    BreakdownVsAvailability,
    CustomNav,
    SummaryTotalBudget,
    BudgetExpanse,
    BudgetPlanVsExpanse,
    SummaryDocking,
    BudgetDockingCategory,
    BudgetExpanseVsPlan,
    PlanAndEmergencyDetail
  },
  data() {
    return {
      tabSelected: 1,
      itemTabs: [
        {
          label: 'AVAILABILITY & BREAKDOWN REPORT',
          value: 1,
        },
        {
          label: 'BUDGET REPORT',
          value: 2,
        },
      ],
      params: {
        year: moment().toDate(),
        vehicle_type_ids: [],
        vehicle_ids: []
      },
      vehicleTypes: [],
      loading: false,
      loadingExport: false,
      showDetail: false,
      vehicles: []
    }
  },
  computed: {
    vehicleComputed () {
      const base = this.vehicles.filter(
        (item) => !['HEAVY EQUIPMENT', 'MOTHER VESSEL'].includes(item?.vehicleType?.name)
      )
      const selected = this.params?.vehicle_type_ids || []
      if (Array.isArray(selected) && selected.length > 0) {
        const ids = selected.map((v) => (typeof v === 'object' ? v.id : v))
        return base.filter((item) => ids.includes(item?.vehicleType?.id))
      }
      return base
    }
  },
  methods: {
    ...fleetsActions,
    ...vehiclesActions,
    ...srActions,
    async handleExportTechnical () {
      try {
        this.loadingExport = true
        const body = {
          year: this.params.year ? parseInt(moment(this.params.year).format('YYYY')) : undefined,
          vehicle_type_ids: this.params?.vehicle_type_ids.map(v => (typeof v === 'object' ? v.id : v)),
          vehicle_ids: this.params?.vehicle_ids.map(v => (typeof v === 'object' ? v.id : v)),
        }
        const params = {}
        const res = await this.exportTechnicalPercentageFleetAvailabilityYearly({ body, params })
        saveAs(res.data, 'technical_percentage_fleet_availability_yearly.xlsx')
      } catch (e) {
        console.error(e)
        this.$swal({ title: 'Export failed', icon: 'error' })
      } finally {
        this.loadingExport = false
      }
    },
    async getVehicleTypes() {
      this.loading = true
      try {
        const response = await this.getFleetTypes()
        this.vehicleTypes = response.data.filter(row => !["HEAVY EQUIPMENT", "MOTHER VESSEL"].includes(row.name))
      } catch (error) {
        console.error('Error fetching vehicle types:', error)
      } finally {
        this.loading = false
      }
    },
    async fetchVehicles () {
      try {
        const response = await this.getVehicles({ showAll: true, page: 1, active: true })
        this.vehicles = response.data.data
      } catch {}
    }
  },
  mounted () {
    this.getVehicleTypes()
    this.fetchVehicles()
  }
}
</script>
